import { combineReducers } from 'redux';
import parameterReducer from './parameters/parameterReducer';
import productsReducer from './products/productsReducer';
import appKeyReducer from './appKeys/appKeyReducer';

const rootReducer = combineReducers({
  productParameter: parameterReducer,
  products: productsReducer,
  appKeys: appKeyReducer,
});

export default rootReducer;
